const fleet = [
    {
        vehicle_name: "escalade",
        vehicle_img: "images/escalade_SUV.jpg",
        make_and_model: "Cadillac Escalade",
        image_alt: "An image of Cadillac Escalade"
    },
    {
        vehicle_name: "suburban",
        vehicle_img: "images/blk_chevy_suburban.jpg",
        make_and_model: "Chevrolet Suburban",
        image_alt: "An image of Chevrolet Suburban"
    },
    {
        vehicle_name: "hyundai",
        vehicle_img: "images/hyundai_SUV.jpg",
        make_and_model: "BMW 7 Series",
        image_alt: "An image of BMW 7 Series"
    },
    {
        vehicle_name: "hummer",
        vehicle_img: "images/hummer_h2.jpg",
        make_and_model: "Mercedes Benz S Class",
        image_alt: "An image of Mercedes Benz S Class"
    },
    {
        vehicle_name: "mercedes",
        vehicle_img: "images/mercedes_benz.jpg",
        make_and_model: "Mercedes Benz Sprinter",
        image_alt: "An image of Mercedes Benz Sprinter"
    },
    {
        vehicle_name: "jeep",
        vehicle_img: "images/jeep_wrangler.jpg",
        make_and_model: "Passenger Bus",
        image_alt: "An image of Passenger Bus"
    }
]

export default fleet;